import { createReducer, createStandardAction } from "typesafe-actions";
import { EntitleResultStatus } from "generated/graphql.schema";
import { TableViewSelectedDevice } from "./PolyPlusAssignmentDevices";

export type AssignMethod = "MANUAL" | "AUTOMATIC" | "";

/**
 * NOTES ON SCHEMA for licenseAggregation:
 * activeLicenseCount: total licenses purchased & not expired - irrespective of whether used or not.
 * availableLicenseCount: total licenses purchased & not expired and not used.
 * expiredLicenseCount:  total count of expired licenses, irrespective of used or not.
 *
 * eligibleDeviceCount: eligible to be licensed - irrespective of assigned or not.
 * availableDeviceCount: total devices in inventory that are eligible to be licensed and not yet assigned.
 * entitledDeviceCount:  total devices (model) in inventory that are assigned licenses.
 */
export interface SelectedModel {
  id: string;
  name: string;
  availableDeviceCount: number;
  availableLicenseCount: number;
  entitledDeviceCount: number;
}
export type AssignModels = Array<SelectedModel>;
type ModelId = string;
export type AssignDevices = Array<TableViewSelectedDevice>;

export interface AssignResults {
  assigned: Array<ModelId>;
  errors: Array<{ modelId: string; error: EntitleResultStatus }>;
}

export interface AssignmentState {
  currentStep: number;
  numSteps: number;
  method: AssignMethod;
  selectedModels: AssignModels;
  selectedDevices: AssignDevices;
  assigned: AssignResults["assigned"];
  errors: AssignResults["errors"];
}

export const assignStep = createStandardAction("ASSIGN_STEP")<number>();
export const assignMethod = createStandardAction("ASSIGN_METHOD")<
  AssignMethod
>();
export const assignModels = createStandardAction("ASSIGN_MODEL")<
  AssignModels
>();
export const assignDevices = createStandardAction("ASSIGN_DEVICES")<
  AssignDevices
>();
export const assignResults = createStandardAction("ASSIGN_RESULTS")<
  AssignResults
>();

export const defaultPolyPlusAssignmentState: AssignmentState = {
  currentStep: 0,
  numSteps: 0,
  method: "",
  selectedModels: [],
  selectedDevices: [],
  assigned: [],
  errors: []
};

export const PolyPlusAssignmentReducer = createReducer(
  defaultPolyPlusAssignmentState
)
  .handleAction(assignStep, (state, action) => {
    return {
      ...state,
      currentStep: action.payload
    };
  })
  .handleAction(assignMethod, (state, action) => {
    return {
      ...state,
      method: action.payload
    };
  })
  .handleAction(assignModels, (state, action) => {
    return {
      ...state,
      selectedModels: action.payload
    };
  })
  .handleAction(assignDevices, (state, action) => {
    return {
      ...state,
      selectedDevices: action.payload
    };
  })
  .handleAction(assignResults, (state, action) => {
    return {
      ...state,
      assigned: action.payload.assigned,
      errors: action.payload.errors
    };
  });
